/**
 * card-pharmashopi-add.js — handler add-to-cart pour les cards Pharmashopi
 * sur les pages collection.
 *
 * Pattern identique à inline-products.js (carrousel inline du blog) :
 * - Listener global délégué sur '.card-pharmashopi-cta-add'
 * - POST /cart/add.js puis swap label success ~1.8s
 * - Dispatch 'cart:item-added' + 'cart:refresh' pour notifier le mini-cart
 *
 * Tous les labels viennent des data-* attributes (rendus côté serveur via locales).
 */
(function () {
  'use strict';

  const SUCCESS_TIMEOUT = 1800;
  const ERROR_TIMEOUT = 1800;

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.card-pharmashopi-cta-add');
    if (!btn) return;
    if (btn.classList.contains('is-loading')) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const labelEl = btn.querySelector('.card-pharmashopi-cta-label') || btn;
    const originalLabel = btn.dataset.addLabel || labelEl.textContent;
    const successLabel = btn.dataset.successLabel || originalLabel;
    const errorLabel = btn.dataset.errorLabel || originalLabel;

    btn.classList.add('is-loading');
    btn.disabled = true;

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
        }),
      });

      if (!response.ok) {
        throw new Error(`Cart add failed (${response.status})`);
      }

      const payload = await response.json();

      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      labelEl.textContent = successLabel;

      document.dispatchEvent(
        new CustomEvent('cart:item-added', {
          detail: { items: payload.items || [], source: 'card-pharmashopi' },
        })
      );
      document.dispatchEvent(
        new CustomEvent('cart:refresh', { detail: { source: 'card-pharmashopi' } })
      );

      window.setTimeout(() => {
        btn.classList.remove('is-success');
        labelEl.textContent = originalLabel;
        btn.disabled = false;
      }, SUCCESS_TIMEOUT);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[card-pharmashopi] add to cart error:', err);
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      labelEl.textContent = errorLabel;

      window.setTimeout(() => {
        btn.classList.remove('is-error');
        labelEl.textContent = originalLabel;
        btn.disabled = false;
      }, ERROR_TIMEOUT);
    }
  });
})();
